import React from "react";
import "./Footer.scss";
import aplicLogo from "../../components/assets/aplic-logo-nb.png";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <button className="register-btn" onClick={() => window.open("https://aplic2027.gottit.io/", "_blank")}>
          <span className="btn-text">Register Now</span>
        </button>
          <img src={aplicLogo} alt="APLIC Logo" className="footer-logo" />
        </div>

        <div className="footer-right">
           <div className="footer-col">
            <a href="/about-us">2027 | APLIC</a>
            <a href="/whats-fun">ABOUT PH</a>
            <a href="/our-team">OUR TEAM</a>
            <a href="/speakers">SPEAKERS</a>
            <a href="/venue">VENUE</a>
            <a href="/">CONTACT</a>
          </div>

          <div className="footer-divider" />
          <hr className="footer-divider-hr"></hr>

          <div className="footer-col">
            <a href="/our-team">LIFE UNDERWRITERS ASSOCIATION OF THE PHILIPPINES</a>
            <a href="/our-team">ASIA PACIFIC FINANCIAL SERVICES ASSOCIATION</a>
            <a href="/venue">SMX CONVENTION CENTER</a>
            <a href="/" className="footer-socials">FACEBOOK</a>
            <a href="/">INSTAGRAM</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>2027 | APLIC</p>
      </div>
    </footer>
  );
};

export default Footer;
